import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CommonService} from './common.service';
import {ToastMessagesService} from './toast-messages.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  public announcements: any[];
  public announcementsSubject = new BehaviorSubject<any>([]);
  displayAnnouncements = this.announcementsSubject.asObservable();
  constructor(public toastMessagesService: ToastMessagesService, private commonService: CommonService) { }

  getInCompleteAnnouncements() {
    return this.announcements.filter(notification => notification.is_opened === 0);
  }

  getCompletedAnnouncements() {
    return this.announcements.filter(notification => notification.is_opened === 1);
  }

  async getAllAnnouncements(userId: number, force: boolean) {
    try {
      if (force) {
        const notificationRequest = await this.commonService.getList(`people/parents/announcements?parentId=${userId}`);
        this.announcements = notificationRequest.object;
        this.announcementsSubject.next(this.announcements);
      } else {
        // if (!this.notifications) {
        const notificationRequest = await this.commonService.getList(`people/parents/announcements?parentId=${userId}`);
        this.announcements = notificationRequest.object;
        // }
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async updateAnnouncementAsSeen(model: any) {
    try {
      await this.commonService.updateItem('consents/updateAnnouncement', model);
    } catch (e) {
      throw e;
    }
  }
}
